export default __webpack_public_path__ + "static/media/ap-residui.3ca5d647.svg";